import { wealthProApi } from '../../redux/api';
//import { socket } from "../../redux/socket";
import { applyPatch } from "fast-json-patch";

const masterAccountsApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["masterAccountDetails", "masterAccountSummaryDetails", "masterAccountPreferenceSummary"]
})
    .injectEndpoints({
        endpoints: (builder) => ({
            createMasterAccountDetails: builder.mutation({
                query: ({ data }) => ({
                    url: `api/clientdetails/master-accounts`,
                    method: 'POST',
                    body: data
                })
            }),
            getMasterAccountDetails: builder.query({
                query: ({ masterAccountId }) => `api/clientdetails/master-accounts/${masterAccountId}`,
                providesTags: ({ masterAccountId }) => [{ type: 'masterAccountDetails', id: masterAccountId }]
            }),
            getMasterAccountDetailSummary: builder.query({
                query: ({ masterAccountId }) => `api/clientdetails/master-accounts/${masterAccountId}/summary`,
                providesTags: (result, err) =>
                    result && !err
                        ? [{ type: 'masterAccountSummaryDetails', id: result.masterAccountId }]
                        : ['masterAccountSummaryDetails']
            }),
            getMasterAccountPreferenceSummary: builder.query({
                query: ({ masterAccountId }) => `api/clientdetails/master-accounts/${masterAccountId}/preferences/summary`,
                providesTags: (result, err) =>
                    result && !err
                        ? [{ type: 'masterAccountPreferenceSummary', id: result.masterAccountId }]
                        : ['masterAccountPreferenceSummary']
            }),
            patchMasterAccountDetails: builder.mutation({
                query: ({ masterAccountId, operations }) => ({
                    url: `api/clientdetails/master-accounts/${masterAccountId}`,
                    method: 'PATCH',
                    body: operations
                }),
                async onQueryStarted({ masterAccountId, operations }, { dispatch, queryFulfilled }) {
                    const result = dispatch(wealthProApi.util.updateQueryData('getMasterAccountDetails', { masterAccountId }, (data) => {
                        applyPatch(data, operations, true);
                    }));

                    // const fetchResult = dispatch(wealthProApi.util.updateQueryData('fetchMasterAccounts', {}, (data) => {
                    //     // var i = data.results.findIndex(el => el.masterAccountId === masterAccountId);
                    //     // if (i >= 0) {
                    //     //     data.results[i].custodianMatchingStatus = 1;
                    //     // }
                    //     applyPatch(data, operations, true);
                    // }));
                    
                    // console.log(fetchResult.patches);
                    try {
                        await queryFulfilled;
                        const updatedVulnerableStatus = operations.some((op) => op.path === "/isVulnerable");
                        if (updatedVulnerableStatus) {
                            dispatch(wealthProApi.util.invalidateTags([{ type: 'masterAccountSummaryDetails', masterAccountId }]));
                        }                     
                    }
                    catch {
                        result.undo();
                        // fetchResult.undo();
                    }
                },
                invalidatesTags:['clientsearchmasteraccounts']
            })
        })
    });

export const {
    useCreateMasterAccountDetailsMutation,
    useGetMasterAccountDetailSummaryQuery,
    useGetMasterAccountDetailsQuery,
    useGetMasterAccountPreferenceSummaryQuery,
    useLazyGetMasterAccountPreferenceSummaryQuery,
    useLazyGetMasterAccountDetailSummaryQuery,
    useLazyGetMasterAccountDetailsQuery,
    usePatchMasterAccountDetailsMutation
} = masterAccountsApiEndpoints;